import { useMemo } from 'react'

import { HIDE_DTI_PRICING_VERSION } from '@/constants/globals'
import { useCurrentApplication } from '@/graphql/services/application'

const useShouldHideDTI = () => {
  const { data: application } = useCurrentApplication()

  const shouldHideDTI = useMemo(() => {
    return application?.pricingVersion >= HIDE_DTI_PRICING_VERSION
  }, [application])

  return shouldHideDTI
}

export default useShouldHideDTI
